import { atom } from "recoil";
import { Card } from "../../models";

export const withRestaurants = atom({
    key: 'withRestaurants',
    default: [] as Card[]
})